import IProjectOutput from "@/api/models/IProjectOutput";
import IOrderOutput from "@/api/models/IOrderOutput";
import { jsonToFormData } from "@/helpers/formData";
import { isNewProject } from "@/preferences";

export default (project: IProjectOutput, order: IOrderOutput) => {
  const date = new Date();
  const d = new FormData();
  d.append("project[id]", project.id);
  d.append("project[name]", project.name);
  if (project.iconFile) {
    d.append("project[icon]", project.iconFile);
  }
  d.append("project[start]", project.start);
  if (project.end) {
    d.append("project[end]", project.end);
  }
  d.append("project[postcode]", project.postcode);
  d.append("project[address]", project.address);
  d.append("project[latitude]", String(project.latitude));
  d.append("project[longitude]", String(project.longitude));
  d.append("project[projectStatusId]", String(project.state));
  d.append("project[note]", project.note);
  d.append("project[tgId]", project.tgId);
  d.append("project[sSystemId]", project.sSystemId);
  d.append("project[OHANo]", project.OHANo);
  d.append("project[holdOut]", String(project.holdOut));
  d.append("project[contractDate]", project.contractDate);
  d.append("order[id]", order.id);
  d.append("order[officeId]", order.clientId);
  d.append("order[staffId]", order.clientStaffId);
  d.append("order[state]", String(order.state));
  d.append("order[endUser]", String(order.endUser));
  if (project.templateId) {
    d.append("project[templateId]", String(project.templateId));
  }
  d.append("project[beforeTemplateId]", String(project.beforeTemplateId));
  project.additionalProperties.forEach((property, i) => {
    d.append(`project[additionalProperties][${i}][keyId]`, property.key.id);
    d.append(`project[additionalProperties][${i}][value]`, property.value);
  });
  
  if (project.taskDefaults && project.taskDefaults.length) {
    project.taskDefaults.forEach((property, i) => {
      d.append(`project[taskDefaults][${i}][keyId]`, property.key.id);
      d.append(`project[taskDefaults][${i}][value]`, property.value);
      if (property.task) jsonToFormData(property.task as object, d, `project[taskDefaults][${i}][task]`);
    });
  }

  if (project.constructionType) {
    d.append("project[constructionTypeId]", project.constructionType as string);
  }

  if (project.responsiblePerson) {
    d.append("project[responsiblePerson]", project.responsiblePerson);
  }

  if (isNewProject(project.created)) {
    const isExpiredTimeClosed = project.end ? new Date(project.end).getTime() <= date.getTime() : false;
    d.append("project[closed]", String(isExpiredTimeClosed));
  } else {
    d.append("project[closed]", String(project.closed));
  }

  return d;
};
